// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as GameTypeData$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/GameTypeData.res.mjs";
import * as AcademyComponents$LiteracyplanetClientSxEntry from "./AcademyComponents.res.mjs";
import * as AcademyActivitiesQuery$LiteracyplanetClientSxEntry from "./AcademyActivitiesQuery.res.mjs";

function trophyForResult(resultPercentage) {
  if (resultPercentage > 84) {
    return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.GoldTrophy.make, {});
  } else if (resultPercentage > 74) {
    return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.SilverTrophy.make, {});
  } else if (resultPercentage > 64) {
    return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.BronzeTrophy.make, {});
  } else {
    return null;
  }
}

function progressColorForResult(resultPercentage) {
  if (resultPercentage > 84) {
    return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.GreenProgressCircle.make, {});
  } else if (resultPercentage > 74) {
    return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.OrangeProgressCircle.make, {});
  } else if (resultPercentage > 64) {
    return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.RedProgressCircle.make, {});
  } else {
    return null;
  }
}

function calcPercent(numerator, denominator) {
  return Math.ceil(numerator / denominator * 100) | 0;
}

function AcademyMenuActivityContainer$ActivityItemComponent(props) {
  var onPlayActivity = props.onPlayActivity;
  var activity = props.activity;
  var progressState = activity.result.started ? "Started" : (
      activity.result.bestScoreNumComplete > 0 ? "Finished" : "NotStarted"
    );
  var resultPercentage = calcPercent(activity.result.bestScoreNumCorrect, activity.result.bestScoreNumComplete);
  return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityItemComponent.make, {
              children: null,
              name: props.name
            }, React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ProgressIconImage.make, {
                  icon: props.icon,
                  progressState: progressState
                }), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityPlay.make, {
                  children: React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityPlayButton.make, {
                        onClick: (function (param) {
                            Curry._1(onPlayActivity, undefined);
                          })
                      })
                }), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityPercentage.make, {
                  children: null
                }, activity.result.bestScoreNumComplete > 0 ? progressColorForResult(resultPercentage) : null, React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.PercentageText.make, {
                      children: activity.result.bestScoreNumComplete > 0 ? String(resultPercentage) + "%" : "---"
                    }), activity.result.bestScoreNumComplete > 0 ? trophyForResult(resultPercentage) : null));
}

var ActivityItemComponent = {
  make: AcademyMenuActivityContainer$ActivityItemComponent
};

function AcademyMenuActivityContainer$ActivityItemLoading(props) {
  return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityItem.make, {
              children: null
            }, React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ProgressIconImageLoading.make, {}), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityPlay.make, {
                  children: null
                }), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityPercentage.make, {
                  children: null
                }));
}

var ActivityItemLoading = {
  make: AcademyMenuActivityContainer$ActivityItemLoading
};

function AcademyMenuActivityContainer(props) {
  var onPlayActivity = props.onPlayActivity;
  var state = AcademyActivitiesQuery$LiteracyplanetClientSxEntry.use(props.id, "LEVEL_7");
  var tmp;
  if (typeof state !== "object") {
    tmp = React.createElement(AcademyMenuActivityContainer$ActivityItemLoading, {});
  } else {
    var match = state._0;
    tmp = React.createElement(React.Fragment, {}, React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Header.make, {
              children: null
            }, React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Title.make, {
                  children: "Academy"
                }), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityHeaderTabs.make, {
                  onNavSubCategory: props.onNavSubCategory,
                  strands: match.strands
                })), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivitiesMainBody.make, {
              children: Belt_Array.map(match.activities, (function (activities) {
                      return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivitiesContainer.make, {
                                  children: Belt_Array.map(activities, (function (activity) {
                                          var game = GameTypeData$LiteracyplanetClientFlags.findByGameId(activity.result.kind);
                                          if (game !== undefined) {
                                            return React.createElement(AcademyMenuActivityContainer$ActivityItemComponent, {
                                                        icon: game.meta.icon,
                                                        name: activity.title,
                                                        activity: activity,
                                                        onPlayActivity: (function (param) {
                                                            Curry._1(onPlayActivity, activity.id);
                                                          })
                                                      });
                                          } else {
                                            return null;
                                          }
                                        }))
                                });
                    }))
            }));
  }
  return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Layout.make, {
              children: React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Content.make, {
                    children: tmp
                  })
            });
}

var make = AcademyMenuActivityContainer;

export {
  trophyForResult ,
  progressColorForResult ,
  calcPercent ,
  ActivityItemComponent ,
  ActivityItemLoading ,
  make ,
}
/* react Not a pure module */
